export default "__VITE_ASSET__1407a2db__"